import React from 'react';
import { Link } from 'react-router-dom';
import { TranslateWorkaround } from '../../assets/constants/strings';

const Bookmark = ({
  bookmark,
  index,
  isMobile,
  isSelected,
  handleSelected,
  isDisabled,
  isSmall,
}) => {
  return (
    <div className='card'>
      <div
        className={`card-header ${isDisabled ? 'bookmarkDisabled' : ''}`}
        id={'heading-' + index}
      >
        <input
          type='checkbox'
          checked={isSelected}
          onChange={() => handleSelected(bookmark)}
        />
        <Link
          to={isDisabled ? '' : bookmark.Link}
          target='_blank'
          rel='noreferrer'
        >
          <button
            className='btn btn-link btn-block text-left px-0'
            type='button'
          >
            {!isSmall ? (
              <div className='row mx-0'>
                {/* Title */}
                <div
                  className='col-4 pl-0'
                  data-toggle={isMobile ? 'tooltip' : ''}
                  data-original-title={bookmark.title}
                  title={bookmark.title}
                >
                  <p className='title'>{bookmark.title}</p>
                </div>
                {/* # of Results */}
                <div
                  className='col-4'
                  data-toggle={isMobile ? 'tooltip' : ''}
                  data-original-title={bookmark.documentName}
                  title={bookmark.documentName}
                >
                  <p className='title'>{bookmark.documentName}</p>
                </div>
                {/* Date */}
                <div
                  className='col-2 d-flex justify-content-center'
                  data-toggle={isMobile ? 'tooltip' : ''}
                  data-original-title={bookmark.versionDate}
                  title={bookmark.versionDate}
                >
                  <p className='title'>
                    {bookmark.versionDate && bookmark.versionDate !== 'N/A'
                      ? bookmark.versionDate.toDateString().substr(4, 12)
                      : bookmark.versionDate}
                  </p>
                </div>
                {/* Date */}
                <div
                  className='col-2 d-flex justify-content-center'
                  data-toggle={isMobile ? 'tooltip' : ''}
                  data-original-title={bookmark.levelOne}
                  title={bookmark.levelOne}
                >
                  <p
                    className={`title${TranslateWorkaround(bookmark.levelOne)}`}
                  >
                    {bookmark.levelOne}
                  </p>
                </div>
              </div>
            ) : (
              <div className='d-flex flex-column'>
                {/* Title */}
                <div
                // className='col-4 pl-0'
                >
                  <p className='title'>
                    <b>{bookmark.title}</b>
                  </p>
                </div>

                <p className='title' style={{ fontSize: '0.8rem' }}>
                  {bookmark.documentName}
                </p>
                <div className='d-flex flex-row' style={{ fontSize: '0.8rem' }}>
                  <p className='title'>
                    {bookmark.versionDate && bookmark.versionDate !== 'N/A'
                      ? bookmark.versionDate.toDateString().substr(4, 12)
                      : bookmark.versionDate}
                  </p>
                  &nbsp;&nbsp; - &nbsp;&nbsp;
                  <p
                    className={`title${TranslateWorkaround(bookmark.levelOne)}`}
                  >
                    {bookmark.levelOne}
                  </p>
                </div>
                {isDisabled && (
                  <div style={{ fontSize: '0.8rem' }}>
                    This bookmark is no longer accessible, as your current
                    subscription does not include this regulation.
                  </div>
                )}
              </div>
            )}
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Bookmark;
